import React from 'react';
import { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import Button from '../../../artzu-ui/src/Button';
import ProgressHeader from '../../NewContact/Header';
import '../newFaq.css';
import FaqDropdown from './FaqDropdown';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { withRouter, useHistory } from 'react-router-dom';
import TorontoFooter from '../../Layout/TorontoFooter';
import SFFooter from '../../Layout/SFFooter';
import NYCFooter from '../../Layout/NYCFooter';
import OttawaFooter from '../../Layout/OttawaFooter';

const NewGeneralFaq = () => {
  const [isSearch, setIsSearch] = useState(false);
  const [input, setInput] = useState();
  const [searchVal, setSearchVal] = useState();
  const [searchResult, setSearchResult] = useState(false);

  const history = useHistory();
  const { pathname } = history.location;

  const handleInput = e => {
    // setIsSearch(false);
    setInput(e.target.value);
  };

  const toggleSearchResult = () => {
    setSearchResult(true);
  };

  const toggleSearch = () => {
    setIsSearch(true);
  };

  const closeSearch = () => {
    setIsSearch(false);
  };
  return (
    <div className="new-faq">
      <Helmet>
        <title>FAQ | Autzu</title>
        <meta
          name="description"
          content="Get all the answers to your frequently asked questions."
        />
      </Helmet>
      <ProgressHeader
        persistentTitle
        title="General FAQ"
        back
        onClick={() => {
          history.goBack();
        }}
      />
      <div className="faq-title-container">
        <div className="faq-title">General FAQ</div>
        <div className="faq-subtitle">
          If you have further questions, please visit our{' '}
          <a
            className="phone-number-tablet"
            href={
              pathname.includes('tor')
                ? '/tor/contact'
                : pathname.includes('sf')
                ? '/sf/contact'
                : '/nyc/contact'
            }>
            Contact Us
          </a>{' '}
          page.
        </div>
      </div>
      <div className="faq-search-container">
        <input
          className="faq-search-input"
          placeholder="Type Keywords"
          value={input}
          onChange={handleInput}></input>
        <button
          className={
            input ? 'faq-search-button' : 'faq-search-button-disabled'
          }
          style={{ margin: '0' }}
          onClick={() => {
            input && toggleSearch();
            input && toggleSearchResult();
            setSearchVal(input);
          }}>
          <div className="faq-search-button-container">
            <FontAwesomeIcon icon={faSearch} />
            Search
          </div>
          <div className="faq-search-button-container-mobile">
            <FontAwesomeIcon icon={faSearch} />
          </div>
        </button>
      </div>
      <div className="faq-container">
        <FaqDropdown
          isSearch={isSearch}
          searchVal={searchVal}
          closeSearch={closeSearch}
          setInput={setInput}
          setSearchVal={setSearchVal}
          searchResult={searchResult}
          setSearchResult={setSearchResult}
          city={pathname}
        />
      </div>
      {pathname.includes('tor') ? (
        <TorontoFooter />
      ) : pathname.includes('sf') ? (
        <SFFooter />
      ) : pathname.includes('ott') ? (
        <OttawaFooter />
      ) : (
        <NYCFooter />
      )}
    </div>
  );
};

export default withRouter(NewGeneralFaq);



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/index.js